import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { templates, sizes, imageOptions } from './flatRectangle.constants';
import { areContentItemsEqual, areContextsEqual } from '../utils/templates';
import FocusShader from '../shaders/focus.shader';
import ImageShader from '../shaders/image.shader';
import { DETACHED_SIGNAL, INACTIVE_SIGNAL, SELECTED_SIGNAL } from '../signals';
import { defaultContext, getInitialStyle, getFocusedStyle, unFocusedStyle } from './flatRectangle.style';

export default class FlatRectangle extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          rect: true,
          shader: {
            type: FocusShader,
          },
        },
        Image: {
          shader: {
            type: ImageShader,
          },
        },
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = { ...defaultContext };
  }

  _inactive() {
    this.signal(INACTIVE_SIGNAL, this);
  }

  _detach() {
    this._item = undefined;
    this.signal(DETACHED_SIGNAL, this);
  }

  set item({ content, colorScheme = this._style.colorMode, renderingContext = RENDERING_CONTEXT.GENERAL }) {
    if (areContentItemsEqual(this._item, content) && areContextsEqual(this._renderingContext, renderingContext)) {
      this._item = content;

      return;
    }

    this._renderingContext = renderingContext;
    this._item = content;
    if (colorScheme && colorScheme !== this._style.colorMode) {
      this._style = { screenSize: this._style.screenSize, colorMode: colorScheme };
    }

    const { image, title } = this._item;
    const src = image ? image.src : '';

    this.patch({
      Image: {
        src,
      },
      Title: {
        text: { text: title || '' },
      },
    });
  }

  get item() {
    return this._item;
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(unFocusedStyle);
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._item);

    return true;
  }
}

FlatRectangle.Templates = templates;
FlatRectangle.Sizes = sizes;
FlatRectangle.ImageOptions = imageOptions;
